import React,{useState} from 'react'
import { useLocation } from 'react-router-dom'
import Card from './Card';
import Storeitems from '../data/Storeitems.json'


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


export default function ManPart() {
    const location = useLocation();
    const [section, setSection] = useState(Storeitems[0].man.kit)

    


    
    const navigation = [
        { name: 'درێسی تۆپی پێ', href: Storeitems[0].man.kit , current: false },
        { name: 'تراک سوت', href: Storeitems[0].man.tracksuit, current: false },
        { name: 'T-Shirt', href: Storeitems[0].man.tshirt, current: false },
        { name: 'جانتا و کالە', href: Storeitems[0].man.shoes, current: false },

    ]
    return (
        <>
            <div className='flex flex-row '>
                <div className='flex  justify-end w-full'>
                    <div className="flex space-x-4 flex-wrap justify-end p-1 ">
                        {navigation.reverse().map((item) => (
                            <>
                                <button
                                    key={item.name}
                                    onClick={()=>setSection(item.href)}
                                    className={classNames(
                                        location.pathname === item.href ? ' font-bold  text-penjam' : ' font-bold   text-c7 hover:text-yakam',
                                        'px-3 py-2 text-[12px] font-bold md:text-sm  '
                                    )}
                                    aria-current={item.current ? 'page' : undefined}
                                >
                                    {item.name}
                                </button>
                            </>
                        ))}
                    </div>
                </div>
            </div>
            <Card cata={section} />
        </>
    )
}
